export default __webpack_public_path__ + "static/media/latest_logo.ba982375.svg";